// @ts-nocheck
import * as $ from 'jquery';
import { Cart } from './Models/Cart';
import { AddDepartmentToCartRequest, AddToCartRequest } from './Models/AddToCartRequest';
import { Employee } from './Models/Employee';
import { Department } from './Models/Department';
import { LineItemType } from './Models/LineItemType';
import { CompanyPayingService } from './Models/CompanyPayingService';

export class SelectedSection {
    private selectedListTable: JQuery;
    private selectedListTableBody: JQuery;
    private noSelectedMessage: JQuery;
    private readonly emptyCart: () => any;
    private readonly removeEmployeeFromCart: (employeeId: string) => any;
    private readonly removeDepartmentFromCart: (departmentId: string) => any;
    private readonly changeCartItem: (id: string, type: LineItemType, service: CompanyPayingService, value: boolean) => any;
    private readonly hasTicketAppService: boolean;

    constructor(private container: JQuery, emptyCartCallback: () => any,
            removeEmployeeCallback: (employeeId: string) => any,
            removeDepartmentCallback: (departmentId: string) => any,
            changeCartItemCallback: (id: string, type: LineItemType, service: CompanyPayingService,
            value: boolean) => any) {
        this.selectedListTable = container.find('.selected-list-table');
        this.selectedListTableBody = container.find('#selected-list-tbody');
        this.noSelectedMessage = container.find('.no-selected-message');
        this.emptyCart = emptyCartCallback;
        this.removeEmployeeFromCart = removeEmployeeCallback;
        this.removeDepartmentFromCart = removeDepartmentCallback;
        this.changeCartItem = changeCartItemCallback;
        this.hasTicketAppService = true;
        this.initialize();
    }

    public removeSelected(evt: JQueryEventObject) {
        let button = evt.currentTarget;
        const employeeId = button.getAttribute('data-employee-id');
        const departmentId = button.getAttribute('data-department-id');

        if ($(button).is('[data-remove-all]')) {
            this.emptyCart();
        }

        if (employeeId) {
            this.removeEmployeeFromCart(employeeId);
        } else if (departmentId) {
            this.removeDepartmentFromCart(departmentId);
        }
    }

    public clickServiceCheckbox(evt: JQueryEventObject) {
        const $checkbox = $(evt.currentTarget);
        const serviceName = $checkbox.attr('data-service-name');
        const service = this.getServiceType(serviceName);
        const value = $checkbox.is(':checked');

        if ($checkbox.is('[data-adjust-all]')) {
            let trs = this.selectedListTableBody.find('tr');
            const section = this;
            trs.not('[data-adjust-all]').each(function () {
                let row = $(this);
                row.find(`input[data-service-name='${serviceName}']`).prop('checked', value);
                const departmentId = row.attr('data-department-id');
                const employeeId = row.attr('data-employee-id');
                section.changeCartItem(employeeId, LineItemType.Employee, service, value);
            });
            return;
        }

        const $row = $checkbox.closest('tr');
        const departmentId = $row.attr('data-department-id');
        const employeeId = $row.attr('data-employee-id');

        this.changeCartItem(employeeId, LineItemType.Employee, service, value);
    }

    public getServiceType(serviceName: string): CompanyPayingService {
        if (serviceName === 'ticketApp') {
            return CompanyPayingService.TicketApp;
        }
    }

    public addToCart(currentCart: Cart, request: AddToCartRequest) {
        let existingIndex = currentCart.employees.findIndex(x => x.id === request.employeeId);

        if (existingIndex < 0) {
            currentCart.employees.push(
                new Employee(request.employeeId, request.name, request.department, request.phoneNumber,
                    request.hasTicketApp));
        }
    }

    public addDepartmentToCart(currentCart: Cart, request: AddDepartmentToCartRequest) {
        let existingIndex = currentCart.departments.findIndex(x => x.departmentId === request.departmentId);
        if (existingIndex < 0) {
            currentCart.departments.push(new Department(request.name, request.departmentId));
        }
    }

    public updateList(currentCart: Cart): void {
        let hasDepartments = currentCart.departments && currentCart.departments.length > 0;
        let hasEmployees = currentCart.employees && currentCart.employees.length > 0;

        if (hasDepartments || hasEmployees) {
            this.selectedListTable.show();
            this.noSelectedMessage.hide();
            this.selectedListTableBody.empty();

            if (hasDepartments) {
                let i;
                for (i = 0; i < currentCart.departments.length; i = i + 1) {
                    let department = currentCart.departments[i];

                    let row = $(`<tr data-department-id="${department.departmentId}" />`);
                    row.append($('<td/>'));
                    row.append($('<td/>').text(department.name));
                    row.append($('<td/>'));
                    row.append($('<td/>'));
                    if (this.hasTicketAppService) {
                        row.append($('<td/>').html(SelectedSection.getServiceCheckbox('ticketApp', false)));
                    }
                    row.append($('<td/>').html(
                        `<button class='btn remove-selected' data-department-id='${department.departmentId}'><span class='glyphicon glyphicon-trash'></span></button>`));
                    this.selectedListTableBody.append(row);
                }
            }

            if (hasEmployees) {
                let i;
                let row = this.createSelectAllRow();
                this.selectedListTableBody.append(row);
                for (i = 0; i < currentCart.employees.length; i = i + 1) {
                    let employee = currentCart.employees[i];

                    let row = this.createEmployeeRow(employee);
                    this.selectedListTableBody.append(row);
                }
            }
        } else {
            this.noSelectedMessage.show();
            this.selectedListTable.hide();
        }
    }

    createSelectAllRow(): JQuery {
        let row = $('<tr data-adjust-all />');
        row.append($('<td/>').text('Alle'));
        row.append($('<td/>'));
        row.append($('<td/>'));
        if (this.hasTicketAppService) {
            row.append($('<td class="services"/>').html(SelectedSection.getServiceCheckbox('ticketApp', false, true)));
        } else {
            row.append($('<td class="services"/>').html(SelectedSection.disabledServiceCheckbox()));
        }
        /* Fields for carpool and bicycle which is not supported yet */
        row.append($('<td class="services hide"/>').html(SelectedSection.disabledServiceCheckbox()));
        row.append($('<td class="services hide"/>').html(SelectedSection.disabledServiceCheckbox()));

        row.append($('<td class="actions"/>').html(
            '<button class="btn remove-selected" data-remove-all><i class="bi bi-x-circle"></i></button>'));
        return row;
    }

    createEmployeeRow(employee: any): JQuery {
        let row = $(`<tr data-employee-id='${employee.id}' />`);
        row.append($('<td/>').text(employee.name));
        row.append($('<td/>').text(employee.department));
        row.append($('<td/>').text(employee.phoneNumber));
        if (this.hasTicketAppService) {
            row.append($('<td class="services"/>').html(SelectedSection.getServiceCheckbox('ticketApp', employee.hasTicketApp)));
        } else {
            row.append($('<td class="services"/>').html(SelectedSection.disabledServiceCheckbox()));
        }
        /* Fields for carpool and bicycle which is not supported yet */
        row.append($('<td class="services hide"/>').html(SelectedSection.disabledServiceCheckbox()));
        row.append($('<td class="services hide"/>').html(SelectedSection.disabledServiceCheckbox()));

        row.append($('<td class="actions"/>').html(
            `<button class="btn remove-selected" data-employee-id='${employee.id}'><i class="bi bi-x-circle"></i></button>`));
        return row;
    }

    private static getServiceCheckbox(serviceName: string, value: boolean, isSelectAll?: boolean) {
        return `<input type="checkbox" data-service-name='${serviceName}' class="service-checkbox" ${value ? 'checked' : ''} ${isSelectAll ? 'data-adjust-all' : ''} />`;
    }

    private static disabledServiceCheckbox() {
        return '<i class="not-active bi bi-x-circle-fill"></i>';
    }

    private initialize() {
        this.selectedListTable.on('click', '.remove-selected', (evt) => this.removeSelected(evt));
        this.selectedListTable.on('click', '.service-checkbox', (evt) => this.clickServiceCheckbox(evt));
    }
}
